import React, { FC, useEffect, useRef } from 'react'
import {Container, StyledCheckBox} from './styles'
import Label from '../label'
type CheckBoxProps = {
  title:string|any,
  value:boolean|string,
  onChange:() => void,
  disabled?:boolean,
  customStyles?:any,
  toolTip?:boolean,
  withoutText?:boolean,
  toolTipText?:string,
  inYup?:boolean,
  test_id?:string,
  ariaLabel?:string,
  indeterminate?:boolean,
}

const CheckBox:FC<CheckBoxProps> = (props) => {
  const {
    title,
    value,
    onChange,
    disabled,
    customStyles,
    toolTip=false,
    toolTipText,
    withoutText,
    inYup,
    test_id,
    ariaLabel,
    indeterminate=false,
  } = props
  const inputRef = useRef<HTMLInputElement>(null)

  useEffect(() => {
    if (inputRef.current) {
      inputRef.current.indeterminate = indeterminate
    }
  }, [indeterminate])
  
  return(
    <Container aria-disabled={disabled} $disabled={disabled} data-test-id={test_id} customStyles={customStyles}>
      {/* {(inYup ? value === 'true' : value) ? 
        <CheckBoxImg  src={CheckIcon}/>
      : */}
      {/* @ts-ignore */}
        <StyledCheckBox
          ref={inputRef}
          aria-label={ariaLabel}
          checked={Boolean(inYup ? value === 'true' : value)}
          type='checkbox'
          disabled={disabled}
          onChange={disabled ? undefined : onChange}
        />
      {/* } */}
      {withoutText || title?.length === 0 ? null : <Label toolTip={toolTip} title={title} tooltipText={toolTipText} margin='10px' />}
    </Container>
  )
}

export default CheckBox
